<template>
  <div id="app">
    <p>Sie haben keine Berechtigung für diesen Bereich</p>
  </div>
</template>

<script>
export default {
  name: 'AppBlocked'
}
</script>

<style scoped>
#app {
  margin: auto;
}
</style>